import randomNumberForToday from '../../../../common/utils/randomNumberForToday'

const data: any = [
  {
    id: 19281265,
    name: 'Discy - Social Questions and Answers WordPress Theme',
    description:
      '\n\nDiscy is a stunning, professional and flexible social questions and answers WordPress theme specially designed for Online Communities, Niche Questions and Answers Websites, Marketing Websites, Developers Websites, or any kind of Social Communities.\n\nCreate your online, full-featured question &amp; answer community like StackOverflow, Quora or Yahoo Answers with Discy Now!\n\n\n\n    \n\n    \n\n    \n\n    \n\n    \n\n    \n\nDiscy also come with some extra power to the theme! Detailed Question Page, Awesome Poll Page, Unique User and Profile Pages, User Points and Badges System, Ask Users, Questions and Answers Report System, Follow Questions, Add Questions to Favorites, Vote Up/Down System, Best Answer Picker, Notifications , Activity Log, Private Mess',
    site: 'themeforest.net',
    classification: 'wordpress/miscellaneous',
    price_cents: 5900,
    number_of_sales: 1161,
    author_username: '2codeThemes',
    author_url: 'https://themeforest.net/user/2codeThemes',
    url:
      'https://themeforest.net/item/discy-social-questions-and-answers-wordpress-theme/19281265',
    summary:
      'Gutenberg Optimized: Yes, High Resolution: Yes, Widget Ready: Yes, Compatible Browsers: IE11, Firefox, Safari, Opera, Chrome, Edge, Compatible With: WPML, Software Version: WordPress 5.4.x, WordPress 5.3.x, WordPress 5.2.x, WordPress 5.1.x, WordPress 5.0.x, WordPress 4.9.x, WordPress 4.8.x, WordPress 4.7.x, WordPress 4.6.1, WordPress 4.6, WordPress 4.5.x, WordPress 4.5.2, WordPress 4.5.1, WordPress 4.5, Columns: 4+',
    rating: { rating: 5, count: 236 },
    updated_at: '2020-05-21T12:42:16+10:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/276575965/thumbnail.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/290219118/01_preview.__large_preview.png'
      },
      live_site: {
        url:
          'https://themeforest.net/item/discy-social-questions-and-answers-wordpress-theme/full_screen_preview/19281265'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/290219118/01_preview.__large_preview.png',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/290219118/01_preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=605b4b57ad441c1b02ecd05846b6a946',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      { name: 'columns', value: '4+' },
      {
        name: 'compatible-browsers',
        value: ['IE11', 'Firefox', 'Safari', 'Opera', 'Chrome', 'Edge']
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.4.x',
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x',
          'WordPress 4.9.x',
          'WordPress 4.8.x',
          'WordPress 4.7.x',
          'WordPress 4.6.1',
          'WordPress 4.6',
          'WordPress 4.5.x',
          'WordPress 4.5.2',
          'WordPress 4.5.1',
          'WordPress 4.5'
        ]
      },
      { name: 'compatible-with', value: ['WPML'] },
      {
        name: 'demo-url',
        value: 'https://2code.info/demo/themes/Discy/Main/'
      },
      { name: 'documentation', value: 'Well Documented' },
      { name: 'framework', value: null },
      { name: 'gutenberg-optimized', value: 'Yes' },
      { name: 'high-resolution', value: 'Yes' },
      { name: 'layout', value: 'Responsive' },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'CSS Files', 'JS Files']
      },
      { name: 'widget-ready', value: 'Yes' }
    ],
    key_features: [
      'Questions And Answers With Points And Badges',
      'Advanced Theme Options And User Profile Page',
      'Responsive Layout with Ajax Search'
    ],
    image_urls: [],
    tags: [
      'ask questions',
      'community',
      'discussion',
      'get answers',
      'helpdesk',
      'how to theme',
      'knowledge base',
      'points and badges',
      'q & a',
      'Q/A',
      'question and answer',
      'questions & answers',
      'rtl',
      'trending',
      'wiki answers'
    ],
    discounts: []
  },
  {
    id: 18194026,
    name: 'Admania - Adsense WordPress Theme With Gutenberg Compatibility',
    description:
      'Admania is a perfect ad-optimized WordPress theme for the Adsense users and Affiliate Marketers which has exclusively been designed to boost their Ad earnings by increasing the click-through rate (CTR). This excellent Adsense-ready template is 100% Gutenberg compatible and hence it supports all native Gutenberg blocks. Moreover, the Admania WordPress theme supports AMP feature and dedicated mobile design to look stunning on smartphones. As the site loading speed is the Google ranking factor, we have done the speed optimization techniques and scored high in the site speed tests to offer the fast loading website. \n\nHaving user-friendly settings that allow you to add/edit the Ads through the front-end ad live editor is the exciting feature of ',
    site: 'themeforest.net',
    classification: 'wordpress/blog-magazine',
    price_cents: 3900,
    number_of_sales: 1882,
    author_username: 'userthemes01',
    author_url: 'https://themeforest.net/user/userthemes01',
    url:
      'https://themeforest.net/item/admania-best-ad-optimized-wordpress-theme-for-adsense-affiliate-enthusiasts/18194026',
    summary:
      'Gutenberg Optimized: Yes, High Resolution: Yes, Widget Ready: Yes, Compatible Browsers: IE9, IE10, IE11, Firefox, Safari, Opera, Chrome, Edge, Compatible With: Elementor, Events Calendar, WooCommerce 4.0.x, WooCommerce 3.9.x, WooCommerce 3.8.x, WooCommerce 3.7.x, WPML, Software Version: WordPress 5.3.x, WordPress 5.2.x, WordPress 5.1.x, WordPress 5.0.x, WordPress 4.9.x, WordPress 4.8.x, WordPress 4.7.x, Columns: 4+',
    rating: { rating: 5, count: 122 },
    updated_at: '2020-01-12T06:49:19+11:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/279036907/Thumbnail.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/279036908/Preview-Images/preview_01.__large_preview.png'
      },
      live_site: {
        url:
          'https://themeforest.net/item/admania-best-ad-optimized-wordpress-theme-for-adsense-affiliate-enthusiasts/full_screen_preview/18194026'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/279036908/Preview-Images/preview_01.__large_preview.png',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/279036908/Preview-Images/preview_01.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=da1f4beb2ae672688533a711d4f4f1ee',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      { name: 'columns', value: '4+' },
      {
        name: 'compatible-browsers',
        value: [
          'IE9',
          'IE10',
          'IE11',
          'Firefox',
          'Safari',
          'Opera',
          'Chrome',
          'Edge'
        ]
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x',
          'WordPress 4.9.x',
          'WordPress 4.8.x',
          'WordPress 4.7.x'
        ]
      },
      {
        name: 'compatible-with',
        value: [
          'Elementor',
          'Events Calendar',
          'WooCommerce 4.0.x',
          'WooCommerce 3.9.x',
          'WooCommerce 3.8.x',
          'WooCommerce 3.7.x',
          'WPML'
        ]
      },
      { name: 'demo-url', value: 'https://admania.userthemes.net/' },
      { name: 'documentation', value: 'Well Documented' },
      { name: 'framework', value: null },
      { name: 'gutenberg-optimized', value: 'Yes' },
      { name: 'high-resolution', value: 'Yes' },
      { name: 'layout', value: 'Responsive' },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'HTML Files', 'CSS Files', 'JS Files']
      },
      { name: 'widget-ready', value: 'Yes' }
    ],
    key_features: [
      'Front End Ad Live Editor',
      'Increase Adsense CTR',
      'Sticky Header Ad, Footer Ad & Sidebar Ad'
    ],
    image_urls: [],
    tags: [
      'adblog',
      'adsense',
      'advertisement',
      'affiliate',
      'blog',
      'blogging',
      'gutenberg',
      'magazine',
      'speed optimization'
    ],
    discounts: []
  },
  {
    id: 20035321,
    name: 'BoxShop - Responsive WooCommerce WordPress Theme',
    description:
      '\nVersion 1.3.6\n- Compatible with WordPress 5.4.1\n- Compatible with WooCommerce 4.1.0\n\nBoxShop is a WooCommerce WordPress theme designed for shopping online stores. We have included multiple layouts for home page, product page to give you best selections in customization. BoxShop is suitable for the eCommerce websites such as supermarket, furniture, glasses, shoes, fashion, electronics, houseware, organic … or anything you want.\nBoxShop is a professional WordPress theme. It comes with a lot of features and variations: Responsive Layout, Mega Menu, Page Builder, Awesome Slider Revolution, RTL, Product Quick View, Ajax Search, Ajax Cart, Easy One Click To Install, ... and so much more.\nEasy to use, awesome and powerful. These are the words tha',
    site: 'themeforest.net',
    classification: 'wordpress/ecommerce/woocommerce',
    price_cents: 5900,
    number_of_sales: 1742,
    author_username: 'skygroup',
    author_url: 'https://themeforest.net/user/skygroup',
    url:
      'https://themeforest.net/item/boxshop-responsive-woocommerce-wordpress-theme/20035321',
    summary:
      'Gutenberg Optimized: No, High Resolution: Yes, Widget Ready: Yes, Compatible Browsers: IE11, Firefox, Safari, Opera, Chrome, Edge, Compatible With: bbPress 2.5.x, WooCommerce 4.0.x, WooCommerce 3.9.x, WooCommerce 3.8.x, WooCommerce 3.7.x, WooCommerce 3.6.x, WooCommerce 3.5.x, WPBakery Page Builder 6.1.x, WPBakery Page Builder 6.0.x, WPML, Software Version: WordPress 5.4.x, WordPress 5.3.x, WordPress 5.2.x, WordPress 5.1.x, WordPress 5.0.x, Columns: 3',
    rating: { rating: 5, count: 115 },
    updated_at: '2020-05-07T18:50:27+10:00',
    trending: true,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/288613442/Thumbnail.jpg',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/288613444/Preview.__large_preview.jpg'
      },
      live_site: {
        url:
          'https://themeforest.net/item/boxshop-responsive-woocommerce-wordpress-theme/full_screen_preview/20035321'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/288613444/Preview.__large_preview.jpg',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/288613444/Preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=20a47248234004b5661f847e4eb53c01',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      { name: 'columns', value: '3' },
      {
        name: 'compatible-browsers',
        value: ['IE11', 'Firefox', 'Safari', 'Opera', 'Chrome', 'Edge']
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.4.x',
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x'
        ]
      },
      {
        name: 'compatible-with',
        value: [
          'bbPress 2.5.x',
          'WooCommerce 4.0.x',
          'WooCommerce 3.9.x',
          'WooCommerce 3.8.x',
          'WooCommerce 3.7.x',
          'WooCommerce 3.6.x',
          'WooCommerce 3.5.x',
          'WPBakery Page Builder 6.1.x',
          'WPBakery Page Builder 6.0.x',
          'WPML'
        ]
      },
      {
        name: 'demo-url',
        value: 'http://demo.theme-sky.com/boxshop/intro-page/'
      },
      { name: 'documentation', value: 'Well Documented' },
      { name: 'framework', value: null },
      { name: 'gutenberg-optimized', value: 'No' },
      { name: 'high-resolution', value: 'Yes' },
      { name: 'layout', value: 'Responsive' },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'CSS Files', 'JS Files']
      },
      { name: 'widget-ready', value: 'Yes' }
    ],
    key_features: [
      '8+ Unique Homepages',
      'Powerful Theme Options, Easy Customize',
      'One Click Import Demo Content'
    ],
    image_urls: [],
    tags: [
      'blog',
      'creative',
      'deals',
      'dokan',
      'ecommerce',
      'electronic',
      'fashion',
      'furniture',
      'glasses',
      'organic',
      'parallax',
      'portfolio',
      'shoes',
      'shop',
      'supermarket'
    ],
    discounts: []
  },
  {
    id: 23239259,
    name: 'Listeo - Directory & Listings With Booking - WordPress Theme',
    description:
      'Listeo is all-in-one WordPress directory theme with front-end user dashboard, built-in booking system, private messagging and many more gorgeous features!  No paid extentions and no coding knowledge required.\n\nBuild a professional directory &amp; classifieds website like TripAdvisor, Yelp, Airbnb, Booking.com, Tripping, FlipKey, HomeAway or similar in minutes!\n\n\tChangelog (version 1.3 is out) – check what’s new ➝\nFacebok – Official Users’ Group ➝\n\n\n➝ Free OpenStreetMap support for maps and location autocomplete –  no need to use paid Google API anymore!\n➝\n iCal Sync\n\n\n    \n        \n            \n                \n            \n        \n\n        \n            \n                \n            \n            \n    \n\n\n\t\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nUser Dashboard\nLis',
    site: 'themeforest.net',
    classification: 'wordpress/corporate/directory-listings',
    price_cents: 6900,
    number_of_sales: 1990,
    author_username: 'purethemes',
    author_url: 'https://themeforest.net/user/purethemes',
    url:
      'https://themeforest.net/item/listeo-directory-listings-wordpress-theme/23239259',
    summary:
      'Gutenberg Optimized: No, High Resolution: Yes, Widget Ready: Yes, Compatible Browsers: Firefox, Safari, Chrome, Edge, Compatible With: Visual Composer 5.1.x, WooCommerce 3.9.x, WooCommerce 3.8.x, WPBakery Page Builder 5.7.x, WPBakery Page Builder 5.6.x, WPBakery Page Builder 5.5.x, Bootstrap 4.x, Bootstrap 3.x, Framework: Underscores, Software Version: WordPress 5.4.x, WordPress 5.3.x, WordPress 5.2.x, WordPress 5.1.x, WordPress 5.0.x',
    rating: { rating: 5, count: 113 },
    updated_at: '2020-05-16T08:22:12+10:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/259696046/av.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/260555519/01_listeo.__large_preview.png'
      },
      live_site: {
        url:
          'https://themeforest.net/item/listeo-directory-listings-wordpress-theme/full_screen_preview/23239259'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/260555519/01_listeo.__large_preview.png',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/260555519/01_listeo.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=13d98398309d0012ed4d6b2437d88761',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/260555519/02_listeo.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=68c6651b354063807c0daa02fef196de',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/260555519/03_listeo.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=f3886e3335c368c46035697ec758f5c8',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/260555519/04_listeo.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=ae13300c14394084cd07aba2aa424df2',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/260555519/05_listeo.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=01edf44c5c77844a7cd0725386f4bd78',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      { name: 'columns', value: null },
      {
        name: 'compatible-browsers',
        value: ['Firefox', 'Safari', 'Chrome', 'Edge']
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.4.x',
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x'
        ]
      },
      {
        name: 'compatible-with',
        value: [
          'Visual Composer 5.1.x',
          'WooCommerce 3.9.x',
          'WooCommerce 3.8.x',
          'WPBakery Page Builder 5.7.x',
          'WPBakery Page Builder 5.6.x',
          'WPBakery Page Builder 5.5.x',
          'Bootstrap 4.x',
          'Bootstrap 3.x'
        ]
      },
      { name: 'demo-url', value: 'https://listeo.pro/' },
      { name: 'documentation', value: 'Well Documented' },
      { name: 'framework', value: ['Underscores'] },
      { name: 'gutenberg-optimized', value: 'No' },
      { name: 'high-resolution', value: 'Yes' },
      { name: 'layout', value: 'Responsive' },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'CSS Files', 'JS Files']
      },
      { name: 'widget-ready', value: 'Yes' }
    ],
    key_features: [
      'Built-in Advanced Booking System',
      'Private Messaging',
      'Built-in Monetization Features'
    ],
    image_urls: [],
    tags: [
      'accommodation',
      'airbnb',
      'booking',
      'booking calendar',
      'business directory',
      'city tour',
      'directory',
      'directory theme',
      'local directory',
      'places in town',
      'rentals',
      'reservation',
      'tourism',
      'tripadvisor',
      'yelp'
    ],
    discounts: []
  },
  {
    id: 20167356,
    name: 'Cariera - Job Board WordPress Theme',
    description:
      'Cariera – Job Board WordPress Theme\nCariera is a professional oriented WordPress Theme based on WP Job Manager. It is a complete solution for both Employers and Candidates offering different job layouts, advanced stats, premium dashboard for each user role and advanced searching options. By buying Cariera you won’t need any extra plugins, everything is included in the theme.\n\n\nNo Extra Plugins are required!\nVersion 1.4.5 available now!\nFull Changelog\n\nSubscribe to the Newsletter\n\n\n\n\n\n\n\n\n\n\t\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nTheme Details\nCariera comes with 10 different unique homepages and lots of extra pages for you to modify and choose for your website. With the advanced one click demo importer you will be able to import the demo within minutes and have th',
    site: 'themeforest.net',
    classification: 'wordpress/corporate/directory-listings',
    price_cents: 6900,
    number_of_sales: 565,
    author_username: 'gnodesign',
    author_url: 'https://themeforest.net/user/gnodesign',
    url:
      'https://themeforest.net/item/cariera-job-board-wordpress-theme/20167356',
    summary:
      'Gutenberg Optimized: No, High Resolution: Yes, Widget Ready: Yes, Compatible Browsers: IE10, IE11, Firefox, Safari, Opera, Chrome, Edge, Compatible With: Elementor, WooCommerce 3.6.x, WooCommerce 3.5.x, WooCommerce 3.4.x, WooCommerce 3.3.x, WooCommerce 3.2.x, WooCommerce 3.1.x, WooCommerce 3.0.x, WPBakery Page Builder 6.1.x, WPBakery Page Builder 6.0.x, WPBakery Page Builder 5.7.x, WPBakery Page Builder 5.6.x, WPBakery Page Builder 5.5.x, Bootstrap 4.x, Software Version: WordPress 5.4.x, WordPress 5.3.x, WordPress 5.2.x, WordPress 5.1.x, WordPress 5.0.x, WordPress 4.9.x, WordPress 4.8.x, WordPress 4.7.x, WordPress 4.6.1, WordPress 4.6, Columns: 4+',
    rating: { rating: 5, count: 112 },
    updated_at: '2020-05-14T19:38:40+10:00',
    trending: true,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/281193813/thumbnail.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/289279457/01_preview.__large_preview.jpg'
      },
      live_site: {
        url:
          'https://themeforest.net/item/cariera-job-board-wordpress-theme/full_screen_preview/20167356'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/289279457/01_preview.__large_preview.jpg',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/289279457/01_preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=75b941d9cd39c941946d23b90313e11d',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/289279457/02_cariera.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=108c71b90d0aaac810c4db5fe68aa768',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/289279457/03_cariera.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=6eb98368b5561753062defb8b94eef59',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/289279457/04_cariera.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=380b8b69c7502c7649b9f0dea2e20e1e',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      { name: 'columns', value: '4+' },
      {
        name: 'compatible-browsers',
        value: ['IE10', 'IE11', 'Firefox', 'Safari', 'Opera', 'Chrome', 'Edge']
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.4.x',
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x',
          'WordPress 4.9.x',
          'WordPress 4.8.x',
          'WordPress 4.7.x',
          'WordPress 4.6.1',
          'WordPress 4.6'
        ]
      },
      {
        name: 'compatible-with',
        value: [
          'Elementor',
          'WooCommerce 3.6.x',
          'WooCommerce 3.5.x',
          'WooCommerce 3.4.x',
          'WooCommerce 3.3.x',
          'WooCommerce 3.2.x',
          'WooCommerce 3.1.x',
          'WooCommerce 3.0.x',
          'WPBakery Page Builder 6.1.x',
          'WPBakery Page Builder 6.0.x',
          'WPBakery Page Builder 5.7.x',
          'WPBakery Page Builder 5.6.x',
          'WPBakery Page Builder 5.5.x',
          'Bootstrap 4.x'
        ]
      },
      { name: 'demo-url', value: 'http://cariera.co/' },
      { name: 'documentation', value: 'Well Documented' },
      { name: 'framework', value: null },
      { name: 'gutenberg-optimized', value: 'No' },
      { name: 'high-resolution', value: 'Yes' },
      { name: 'layout', value: 'Responsive' },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'CSS Files', 'JS Files']
      },
      { name: 'widget-ready', value: 'Yes' }
    ],
    key_features: [
      'Fully functional Job Board Theme.',
      'Premium Dashboard for Jobs & Resumes.',
      'No Extra Plugins Required.'
    ],
    image_urls: [],
    tags: [
      'application',
      'candidate',
      'career',
      'employer',
      'employment',
      'job board',
      'job listings directory',
      'job portal',
      'job postings',
      'job theme',
      'jobs',
      'listing',
      'recruitment',
      'resume',
      'wp job manager'
    ],
    discounts: []
  },
  {
    id: 19341019,
    name: 'Fortun | Multi-Concept WordPress Theme',
    description:
      'Fortun is a versatile responsive WordPress theme with 18 modern demos &amp; Visual Composer for building any kind of website imaginable. Incl 6 months support. With fastidious attention to detail, Fortun has been designed and developed from the ground up with the incredible best settling Drag &amp; Drop Page Builder (fully inclusive), to bring you a very unique looking website for those wishing to creating something outstanding.Important: Users who’re all updating to Fortun 1.2 also need to update its required plugin Agni Fortun to 1.1Latest Version 1.2.1.1 Change Log\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nOverview\nWith over 15 current layouts pre-built right out of the box, and the easy to use Demo Importer, you will be up and running with no fuss in the s',
    site: 'themeforest.net',
    classification: 'wordpress/creative',
    price_cents: 5900,
    number_of_sales: 1905,
    author_username: 'AgniHD',
    author_url: 'https://themeforest.net/user/AgniHD',
    url:
      'https://themeforest.net/item/fortun-multiconcept-wordpress-theme/19341019',
    summary:
      'Gutenberg Optimized: No, High Resolution: Yes, Widget Ready: Yes, Compatible Browsers: IE10, IE11, Firefox, Safari, Opera, Chrome, Edge, Compatible With: Visual Composer 5.1.x, WooCommerce 3.5.x, WPBakery Page Builder 5.5.x, WPML, Software Version: WordPress 5.1.x',
    rating: { rating: 5, count: 100 },
    updated_at: '2020-01-30T21:14:13+11:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/225688352/fortun-80x80-9.jpg',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/222661318/01_fortun-590x300.__large_preview.jpg'
      },
      live_site: {
        url:
          'https://themeforest.net/item/fortun-multiconcept-wordpress-theme/full_screen_preview/19341019'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/222661318/01_fortun-590x300.__large_preview.jpg',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/222661318/01_fortun-590x300.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=f1721b4892746a77cc5da95678228f2e',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      { name: 'columns', value: null },
      {
        name: 'compatible-browsers',
        value: ['IE10', 'IE11', 'Firefox', 'Safari', 'Opera', 'Chrome', 'Edge']
      },
      { name: 'compatible-software', value: ['WordPress 5.1.x'] },
      {
        name: 'compatible-with',
        value: [
          'Visual Composer 5.1.x',
          'WooCommerce 3.5.x',
          'WPBakery Page Builder 5.5.x',
          'WPML'
        ]
      },
      {
        name: 'demo-url',
        value: 'http://demo.agnidesigns.com/fortune/demos/'
      },
      { name: 'documentation', value: 'Well Documented' },
      { name: 'framework', value: null },
      { name: 'gutenberg-optimized', value: 'No' },
      { name: 'high-resolution', value: 'Yes' },
      { name: 'layout', value: 'Responsive' },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'CSS Files', 'JS Files']
      },
      { name: 'widget-ready', value: 'Yes' }
    ],
    key_features: [
      'Well crafted frontend & backend design',
      'Google Font, Typkit & Unlimited Custom fonts',
      'Awesome support & Regular updates'
    ],
    image_urls: [],
    tags: [
      'agency',
      'business',
      'corporate',
      'creative',
      'landing page',
      'modern',
      'multipurpose',
      'one page',
      'parallax',
      'personal',
      'portfolio',
      'responsive',
      'startup',
      'visual composer',
      'wordpress theme'
    ],
    discounts: []
  },
  {
    id: 22629398,
    name: 'Elessi - Responsive Shopify Theme',
    description:
      '\nMay 09, 2020: Released version 2.0\n- ADD NEW DEMO: Face Mask Store\n- Optimized some CSS\n- My boss said he would fire us if we didn’t update Elessi. We spent a few days learning new features but Elessi was stable so we couldn’t do it. So we created the home Face Mask to fight the Covid-19 pandemic together. Hopefully, he won’t fire us. \n\n\n\t\n\n\n\n\n\t\n\n\n\nABOUT ELESSI\nElessi is clean, modern, user-friendly Shopify Theme with many of functions theme just perfect for your Fashion eCommerce project.\n\n    Elessi is built with the customer experience in mind with features like: Unique product filtering, Unique Compare, Multiple ajax off-canvas Wishlist &amp; Cart Sidebar, Product Quick View (Off-canvas or Popup), One Click them installs, ... and so mu',
    site: 'themeforest.net',
    classification: 'ecommerce/shopify/fashion',
    price_cents: 6900,
    number_of_sales: 1038,
    author_username: 'The4',
    author_url: 'https://themeforest.net/user/The4',
    url:
      'https://themeforest.net/item/elessi-responsive-shopify-theme/22629398',
    summary:
      'High Resolution: Yes, Compatible Browsers: IE10, IE11, Firefox, Safari, Opera, Chrome, Edge, Compatible With: Bootstrap 4.x, Software Version: Shopify 2.0, Columns: 2',
    rating: { rating: 5, count: 89 },
    updated_at: '2020-05-09T17:50:47+10:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/255634588/Thumbnail.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/288787733/Elessi%202.0.__large_preview.jpg'
      },
      live_site: {
        url:
          'https://themeforest.net/item/elessi-responsive-shopify-theme/full_screen_preview/22629398'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/288787733/Elessi%202.0.__large_preview.jpg',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/288787733/Elessi+2.0.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=b7d9882678cfd19d7a2ad13d744d5a0f',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      { name: 'columns', value: '2' },
      {
        name: 'compatible-browsers',
        value: ['IE10', 'IE11', 'Firefox', 'Safari', 'Opera', 'Chrome', 'Edge']
      },
      { name: 'compatible-software', value: ['Shopify 2.0'] },
      { name: 'compatible-with', value: ['Bootstrap 4.x'] },
      {
        name: 'demo-url',
        value: 'https://themes.the4.co/elessi/landing.html'
      },
      { name: 'documentation', value: 'Well Documented' },
      { name: 'high-resolution', value: 'Yes' },
      { name: 'layout', value: 'Responsive' },
      { name: 'themeforest-files-included', value: ['CSS Files', 'JS Files'] }
    ],
    key_features: [
      'Minimal design optimize for mobile',
      'Made for Dropshipping site',
      'Product page optimize UI-UX'
    ],
    image_urls: [],
    tags: [
      'ajax filter',
      'ajax load',
      'dropshipping',
      'elessi',
      'face mask store',
      'fashion',
      'fashion theme',
      'liquid',
      'mobile friendly',
      'multipurpose',
      'responsive',
      'responsive shopify theme',
      'shopify theme'
    ],
    discounts: []
  },
  {
    id: 24276567,
    name: 'Avone - Multipurpose Shopify Theme',
    description:
      'Latest Version 2.2 – April 28, 2020. View Changelog. Changelog also added at the bottom of this page.\n\n\n\n \n\n    Avone is a new kind of Theme. In few words, it is the most powerful, easy to use shopify theme with unlimited possibilities. It is a fully Responsive Premium shopify Theme with a great design and extensive functionality.\n    Avone features over 1000 Theme Options, making it the most customizable theme in  the market.  Its Powerful Theme Options allows to craft almost any imaginable design.  Avone isn’t missing out on any of the other best eCommerce features either.\n    Avone has all the reasons to be extraordinary.  The goal was to design something that offers all the possible features you need to create your amazing online store ',
    site: 'themeforest.net',
    classification: 'ecommerce/shopify/fashion',
    price_cents: 5900,
    number_of_sales: 1277,
    author_username: 'adornthemes',
    author_url: 'https://themeforest.net/user/adornthemes',
    url:
      'https://themeforest.net/item/avone-multipurpose-shopify-theme/24276567',
    summary:
      'High Resolution: Yes, Compatible Browsers: IE11, Firefox, Safari, Opera, Chrome, Edge, Software Version: Shopify 2.0, Columns: 4+',
    rating: { rating: 5, count: 87 },
    updated_at: '2020-04-28T22:00:56+10:00',
    trending: true,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/278549656/avone-icon-80x80.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/286955578/01_preview.__large_preview.png'
      },
      live_site: {
        url:
          'https://themeforest.net/item/avone-multipurpose-shopify-theme/full_screen_preview/24276567'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/286955578/01_preview.__large_preview.png',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/286955578/01_preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=84bea07164185dff374d4462d4f2357a',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/286955578/02_screen1.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=e6e69a48a7ab65233124083165139934',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/286955578/03_screen2.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=995cad11b95f3f5ba54966e29f6f3ee6',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/286955578/04_screen3.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=9d2ba00343af602a29aecc591bcb8159',
            width: 590,
            height: 300
          },
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/286955578/05_screen4.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=cd81f7e70dcba98529c7c66b6d7c6c10',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      { name: 'columns', value: '4+' },
      {
        name: 'compatible-browsers',
        value: ['IE11', 'Firefox', 'Safari', 'Opera', 'Chrome', 'Edge']
      },
      { name: 'compatible-software', value: ['Shopify 2.0'] },
      { name: 'compatible-with', value: null },
      { name: 'demo-url', value: 'https://www.adornthemes.com/avone/' },
      { name: 'documentation', value: 'Well Documented' },
      { name: 'high-resolution', value: 'Yes' },
      { name: 'layout', value: 'Responsive' },
      { name: 'themeforest-files-included', value: ['CSS Files', 'JS Files'] }
    ],
    key_features: [
      'Incredible Theme Design, Easy Customize',
      '1000+ Theme Options, Unlimited Possibilities',
      'Mobile Optimized & Fast Loading, Reliable'
    ],
    image_urls: [],
    tags: [
      'best shopify 2020',
      'clean',
      'clothing',
      'fashion',
      'fashion shopify theme',
      'furniture',
      'lingerie shopify theme',
      'modern',
      'multipurpose',
      'oberlo dropshipping aliexpress',
      'responsive',
      'shop',
      'shopify',
      'shopping',
      'store'
    ],
    discounts: []
  }
]

const NUM_ITEMS = 4

export default () => {
  const start = randomNumberForToday(0, data.length / NUM_ITEMS) * NUM_ITEMS
  const end = start + NUM_ITEMS
  return {
    data: data.slice(start, end),
    title: 'High-quality themes and templates made by world-class creators',
    subtitle: 'Something for every project and every budget.',
    cta: {
      title: 'View all themes',
      urlSearchParams: {
        sort: 'rating'
      }
    }
  }
}
